// v2.21 — l'apparence d'un agenda Google dans le Planning : la couleur et le style (plein / transparent)
// choisis par clic droit sur sa pastille, sinon la couleur de Google en transparent.
export const calendarLook = (evt, styles = {}) => {
  const s = styles[evt.calendar_id] || {};
  return { color: s.color || evt.calendar_color || '#4285F4', solid: !!s.solid };
};

export const CALENDAR_COLORS = ['#D50000', '#E67C73', '#F4511E', '#F6BF26', '#33B679', '#0B8043',
  '#039BE5', '#3F51B5', '#7986CB', '#8E24AA', '#616161', '#795548'];
